import React, { useEffect, useState } from "react";
import uploadmutiplefile from "../../common/Uploadmultplefile";
import toast from "react-hot-toast";
import formatDate from "../../common/Formatdate";
import ImagePreviewLoop from "../../common/imagepreviewloop";
import { useSelector } from "react-redux";

const Billingdetails = ({
  selectedRow,
  workOrderDetail,
  taggedBookings,
  billingDetails,
  setBillingDetails,
  getBillingDetails,
}) => {
  const apiUrl = process.env.REACT_APP_API_BASE_URL;
  let token = localStorage.getItem("token");
  const workorderStatus = JSON.parse(
    localStorage.getItem("catalogValues"),
  )?.workorderStatus;
  const [formData, setFormData] = useState({});
  const [isEditing, setIsEditing] = useState(false);
  // const [billingDetails, setBillingDetails] = useState(null);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [currentImages, setCurrentImages] = useState([]);
  const [openImage, setOpenImage] = useState(false);
  const [imageSelection, setImageSelection] = useState(null);
  const isSystemUserList = useSelector(
    (state) => state?.isSystemUser?.isSysTemUserData?.entities?.rows,
  );

  console.log("formData", formData);

  const parseImages = (value) => {
    try {
      if (!value) return [];

      if (Array.isArray(value)) return value;

      const parsed = typeof value === "string" ? JSON.parse(value) : value;

      if (Array.isArray(parsed)) return parsed;

      if (typeof parsed === "object") return [parsed];

      return [];
    } catch (e) {
      return [];
    }
  };

  const handleStartEdit = () => {
    if (!billingDetails) return;
    setIsEditing(true);
  };

  const handleCancelEdit = () => {
    setIsEditing(false);
    setFormData({});
  };

  useEffect(() => {
    if (!billingDetails) return;

    setFormData({
      amountPaidByInsurance: billingDetails?.amountPaidByInsurance || "",
      amountPaidByCustomer: billingDetails?.amountPaidByCustomers || "",
      billingAmount: billingDetails?.billingAmount || "",
      taxAmount: billingDetails?.taxAmount || "",
      laborCost: billingDetails?.labourCost || "",
      discountPercentage: billingDetails?.discountPercentage || "",
      discountAmount: billingDetails?.discountAmount || "",
      taxPercentage: billingDetails?.taxPercentage || "",
      cgstPercentage: billingDetails?.cgstPercentage || "",
      cgstAmount: billingDetails?.cgstAmount || "",
      sgstPercentage: billingDetails?.sgstPercentage || "",
      sgstAmount: billingDetails?.sgstAmount || "",
      amountSaved: billingDetails?.amountSaved || "",
      costToCompany: billingDetails?.costToCompany || "",
      invoiceNo: billingDetails?.invoiceNo || "",
      invoiceDate: billingDetails?.invoiceDate?.split("T")[0] || "",
      transactionId: billingDetails?.transactionId || "",
      modeOfPayment: billingDetails?.modeOfPayment || "",
      transactionDate: billingDetails?.transactionDate?.split("T")[0] || "",
      isCreditApplied:
        billingDetails?.isCreditApplied === true ||
        billingDetails?.isCreditApplied === 1
          ? "1"
          : billingDetails?.isCreditApplied === false ||
              billingDetails?.isCreditApplied === 0
            ? "0"
            : "",
      isInsuranceClaimed:
        billingDetails?.isInsuranceClaimed === true ||
        billingDetails?.isInsuranceClaimed === 1
          ? "1"
          : billingDetails?.isInsuranceClaimed === false ||
              billingDetails?.isInsuranceClaimed === 0
            ? "0"
            : "",
      description: billingDetails?.description || "",
      attachment: parseImages(billingDetails?.attachment),
      invoiceBillAttachment: parseImages(billingDetails?.invoiceBillAttachment),
    });
  }, [billingDetails, isEditing]);

  const handleSubmit = (e) => {
    e.preventDefault();
    handleaddBillingDetails();
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleFileChange = async (files, field) => {
    toast.loading("Image Upload Processing... Please wait", {
      id: "upload", // same ID to update later
      position: "bottom-center",
    });
    const res = await uploadmutiplefile(files, "vehicles", "vehicle");

    const uploaded = res?.uploaded || [];
    toast.dismiss("upload");
    setFormData((prev) => ({
      ...prev,
      [field]: [...(prev[field] || []), ...uploaded],
    }));
  };

  const validateBillingDetails = (formData) => {
    let errors = {};

    if (!formData?.billingAmount) {
      errors.billingAmount = "Billing Amount is required";
    }

    if (!formData?.costToCompany) {
      errors.costToCompany = "Cost to Company amount is required";
    }

    if (!formData?.amountSaved) {
      errors.amountSaved = "Amount Saved is required";
    }

    // if (!formData?.totalCost) {
    //   errors.totalCost = "Total Cost is required";
    // }

    if (!formData?.invoiceDate) {
      errors.invoiceDate = "Invoice Date is required";
    }

    if (formData?.isCreditApplied === "" || formData?.isCreditApplied == null) {
      errors.isCreditApplied = "Credit Applied is required";
    }

    if (
      formData?.isInsuranceClaimed === "" ||
      formData?.isInsuranceClaimed == null
    ) {
      errors.isInsuranceClaimed = "Insurance Claimed is required";
    }

    if (!formData?.invoiceBillAttachment) {
      errors.invoiceBillAttachment = "Invoice Bill Attachment is required";
    }

    return errors;
  };

  const handleaddBillingDetails = async () => {
    const errors = validateBillingDetails(formData);

    // If errors exist, show first error and stop
    if (Object.keys(errors).length > 0) {
      Object.values(errors).forEach((err) => toast.error(err));
      return;
    }

    toast.loading("Billing Details adding... Please wait", {
      id: "billingdetails", // same ID to update later
      position: "top-center",
    });

    let payload;

    if (isEditing) {
      payload = {
        id: billingDetails?.id,
        serviceLogId: workOrderDetail?.id,
        vehicleId: workOrderDetail?.vehicleId,
        amountPaidByCustomers: formData?.amountPaidByCustomer,
        taxAmount: formData?.taxAmount,
        invoiceNo: formData?.invoiceNo,
        invoiceDate: formData?.invoiceDate,
        amountPaidByInsurance: formData?.amountReceivedByInsurance,
        billingAmount: formData?.billingAmount,
        discountPercentage: formData?.discountPercentage,
        discountAmount: formData?.discountAmount,
        amountSaved: formData?.amountSaved,
        costToCompany: formData?.costToCompany,
        description: formData?.description,
        attachment: JSON.stringify(formData?.attachment),
        invoiceBillAttachment: JSON.stringify(formData?.invoiceBillAttachment),
        amountPaid: formData?.amountPaid,
        transactionId: formData?.transactionId,
        modeOfPayment: formData?.modeOfPayment,
        transactionDate: formData?.transactionDate,
        isCreditApplied: formData?.isCreditApplied,
        labourCost: formData?.laborCost,
        taxPercentage: formData?.taxPercentage,
        cgstPercentage: formData?.cgstPercentage,
        cgstAmount: formData?.cgstAmount,
        sgstPercentage: formData?.sgstPercentage,
        sgstAmount: formData?.sgstAmount,
        serviceObject: {
          id: workOrderDetail?.id,
          totalAmount: formData?.amountPaid,
          amountClaimed: formData?.amountReceivedByInsurance,
          amountPaidByCustomers: formData?.amountPaidByCustomer,
          isInsuranceClaimed: formData?.isInsuranceClaimed,
        },
      };
    } else {
      payload = {
        serviceLogId: workOrderDetail?.id,
        vehicleId: workOrderDetail?.vehicleId,
        amountPaidByCustomers: formData?.amountPaidByCustomer,
        taxAmount: formData?.taxAmount,
        invoiceNo: formData?.invoiceNo,
        invoiceDate: formData?.invoiceDate,
        amountPaidByInsurance: formData?.amountReceivedByInsurance,
        billingAmount: formData?.billingAmount,
        discountPercentage: formData?.discountPercentage,
        discountAmount: formData?.discountAmount,
        amountSaved: formData?.amountSaved,
        costToCompany: formData?.costToCompany,
        description: formData?.description,
        attachment: JSON.stringify(formData?.attachment),
        invoiceBillAttachment: JSON.stringify(formData?.invoiceBillAttachment),
        amountPaid: formData?.amountPaid,
        transactionId: formData?.transactionId,
        modeOfPayment: formData?.modeOfPayment,
        transactionDate: formData?.transactionDate,
        isCreditApplied: formData?.isCreditApplied,
        labourCost: formData?.laborCost,
        taxPercentage: formData?.taxPercentage,
        cgstPercentage: formData?.cgstPercentage,
        cgstAmount: formData?.cgstAmount,
        sgstPercentage: formData?.sgstPercentage,
        sgstAmount: formData?.sgstAmount,
        serviceObject: {
          id: workOrderDetail?.id,
          totalAmount: formData?.amountPaid,
          amountClaimed: formData?.amountReceivedByInsurance,
          amountPaidByCustomers: formData?.amountPaidByCustomer,
          isInsuranceClaimed: formData?.isInsuranceClaimed,
        },
      };
    }

    // console.log("Payload for Billing Details:", payload);
    // return;
    try {
      const response = await fetch(`${apiUrl}/api/servicelogbillingdetails`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          Authorization: `${token}`,
        },
        body: JSON.stringify(payload),
      });
      const data = await response.json();
      if (data?.statusCode === "0100") {
        toast.dismiss("billingdetails");
        toast.success("Insurance Claim Details Updated Successfully", {
          position: "bottom-center",
          style: {
            background: "blue", // override background
            color: "white",
            fontWeight: "medium",
            marginBottom: "50px",
          },
        });
        setIsEditing(false);
        await getBillingDetails(workOrderDetail?.id);
      } else {
        toast.error(data?.msg);
      }
      return data;
    } catch (error) {
      return console.error("Error fetching POST vehicle details:", error);
    }
  };

  const getImageUrl = (item) => {
    if (!item) return null;
    if (typeof item === "string") return item;
    return item?.url || item?.fileUrl || item?.path || null;
  };

  const handleImageOpen = (img, idx = 0, imagesArray = []) => {
    setImageSelection(getImageUrl(img));
    setCurrentIndex(idx);
    setCurrentImages(imagesArray);
    setOpenImage(true);
  };

  const getFileType = (url = "") => {
    const ext = url.split(".").pop().toLowerCase();

    if (["jpg", "jpeg", "png", "gif", "webp"].includes(ext)) return "image";
    if (["mp4", "webm", "ogg"].includes(ext)) return "video";
    if (["pdf"].includes(ext)) return "pdf";
    if (["doc", "docx", "xls", "xlsx", "ppt", "pptx"].includes(ext))
      return "doc";

    return "other";
  };

  const renderFilePreview = (file, index, allFiles) => {
    const url = file?.url || file;
    const type = getFileType(url);

    const commonClass =
      "w-12 h-12 rounded-lg border cursor-pointer object-cover";

    switch (type) {
      case "image":
        return (
          <img
            key={index}
            src={url}
            alt="attachment"
            className={commonClass}
            onClick={() => handleImageOpen(url, index, allFiles)}
          />
        );

      case "video":
        return (
          <video
            key={index}
            src={url}
            className={commonClass}
            onClick={() => handleImageOpen(url, index, allFiles)}
          />
        );

      case "pdf":
        return (
          <div
            key={index}
            className={`${commonClass} flex items-center justify-center bg-gray-100 text-xs`}
            onClick={() => window.open(url, "_blank")}
          >
            PDF
          </div>
        );

      case "doc":
        return (
          <div
            key={index}
            className={`${commonClass} flex items-center justify-center bg-gray-100 text-xs`}
            onClick={() => window.open(url, "_blank")}
          >
            DOC
          </div>
        );

      default:
        return (
          <div
            key={index}
            className={`${commonClass} flex items-center justify-center bg-gray-100 text-xs`}
            onClick={() => window.open(url, "_blank")}
          >
            FILE
          </div>
        );
    }
  };

  return (
    <>
      {openImage && (
        <ImagePreviewLoop
          imageSelection={imageSelection}
          openImage={openImage}
          setImageSelection={setImageSelection}
          setOpenImage={setOpenImage}
          setCurrentIndex={setCurrentIndex}
          setCurrentImages={setCurrentImages}
          currentIndex={currentIndex}
          currentImages={currentImages}
        />
      )}

      <div>
        <div className="bg-red-50 shadow-sm rounded-xl p-4 w-full flex justify-between my-2">
          <div className="items-center border-b pb-2">
            <span className="text-gray-600 font-medium">
              Damage Amount Collected -
            </span>
            <span className="font-semibold text-lg text-green-600">
              ₹
              {taggedBookings?.reduce(
                (sum, item) => sum + Number(item.damageChargesCollected || 0),
                0,
              )}
            </span>
          </div>

          <div className="items-center">
            <span className="text-gray-600 font-medium">
              Downtime Amount Collected -
            </span>
            <span className="font-semibold text-lg text-blue-600">
              ₹
              {taggedBookings?.reduce(
                (sum, item) => sum + Number(item.downtimeChargesCollected || 0),
                0,
              )}
            </span>
          </div>
        </div>

        {billingDetails && !isEditing ? (
          <>
            <div className="flex justify-between items-center mb-4">
              <h3 className="text-lg font-semibold">Billing Details</h3>
              {[
                Number(workorderStatus?.inverted?.billingApproved),
                Number(workorderStatus?.inverted?.serviceCompleted),
                Number(workorderStatus?.inverted?.enrouteToHub),
              ].includes(Number(workOrderDetail?.serviceStatus)) ? <></> : (
                <button
                  type="button"
                  onClick={handleStartEdit}
                  className="bg-blue-500 text-white px-4 py-2 rounded hover:bg-blue-600"
                >
                  Edit
                </button>
              )}
            </div>
            <div className="grid grid-cols-6 gap-x-6 gap-y-3 text-sm bg-white p-6">
              <p className="font-semibold">Invoice No:</p>
              <p>{billingDetails.invoiceNo || "0"}</p>

              <p className="font-semibold">Invoice Date:</p>
              <p>{formatDate(billingDetails.invoiceDate) || "0"}</p>

              <p className="font-semibold">Billing Amount:</p>
              <p>{billingDetails.billingAmount || "0"}</p>

              <p className="font-semibold">Tax Amount:</p>
              <p>{billingDetails.taxAmount || "0"}</p>

              <p className="font-semibold">Labor Cost:</p>
              <p>{billingDetails.labourCost || "0"}</p>

              <p className="font-semibold">Discount %:</p>
              <p>{billingDetails.discountPercentage || "0"}</p>

              <p className="font-semibold">Discount Amount:</p>
              <p>{billingDetails.discountAmount || "0"}</p>

              <p className="font-semibold">Tax Percentage:</p>
              <p>{billingDetails.taxPercentage || "0"}</p>

              <p className="font-semibold">CGST Percentage:</p>
              <p>{billingDetails.cgstPercentage || "0"}</p>

              <p className="font-semibold">CGST Amount:</p>
              <p>{billingDetails.cgstAmount || "0"}</p>

              <p className="font-semibold">SGST Percentage:</p>
              <p>{billingDetails.sgstPercentage || "0"}</p>

              <p className="font-semibold">SGST Amount:</p>
              <p>{billingDetails.sgstAmount || "0"}</p>

              <p className="font-semibold">Amount Paid By Insurance:</p>
              <p>{billingDetails.amountPaidByInsurance || "0"}</p>

              <p className="font-semibold">Amount Paid By Customer:</p>
              <p>{billingDetails.amountPaidByCustomers || "0"}</p>

              <p className="font-semibold">Amount Paid (Total):</p>
              <p>{billingDetails.amountPaid || "0"}</p>

              <p className="font-semibold">Cost To Company:</p>
              <p>{billingDetails.costToCompany || "0"}</p>

              <p className="font-semibold">Amount Saved:</p>
              <p>{billingDetails.amountSaved || "0"}</p>

              {/* <p className="font-semibold">Mode Of Payment:</p>
              <p>{billingDetails.modeOfPayment || "0"}</p>

              <p className="font-semibold">Transaction ID:</p>
              <p>{billingDetails.transactionId || "-"}</p>

              <p className="font-semibold">Transaction Date:</p>
              <p>{formatDate(billingDetails.transactionDate) || "-"}</p> */}

              <p className="font-semibold">Credit Applied:</p>
              <p>{billingDetails.isCreditApplied ? "Yes" : "No"}</p>

              <p className="font-semibold">Description:</p>
              <p>{billingDetails.description || "-"}</p>

              <p className="font-semibold">Created At:</p>
              <p>{billingDetails.createdAt || "-"}</p>

              <p className="font-semibold">Created By:</p>
              <p>
                {isSystemUserList.find(
                  (user) => user?.id === billingDetails.createdBy,
                )?.name || "-"}
              </p>
            </div>

            <div className="bg-white p-4 rounded-lg">
              <p className="font-semibold my-4">Attachments:</p>
              {parseImages(billingDetails?.attachment)?.length > 0 ? (
                <div className="grid grid-cols-12 gap-2">
                  {parseImages(billingDetails?.attachment).map((file, index) =>
                    renderFilePreview(
                      file,
                      index,
                      parseImages(billingDetails?.attachment),
                    ),
                  )}
                </div>
              ) : (
                <p>-</p>
              )}

              <p className="font-semibold my-4">Invoice Bill:</p>
              {parseImages(billingDetails?.invoiceBillAttachment)?.length >
              0 ? (
                <div className="grid grid-cols-12 gap-2">
                  {parseImages(billingDetails?.invoiceBillAttachment).map(
                    (file, index) =>
                      renderFilePreview(
                        file,
                        index,
                        parseImages(billingDetails?.invoiceBillAttachment),
                      ),
                  )}
                </div>
              ) : (
                <p>-</p>
              )}
            </div>
          </>
        ) : (
          <>
            <form onSubmit={handleSubmit} className="grid grid-cols-3 gap-4">
              <input
                type="number"
                name="amountReceivedByInsurance"
                placeholder="Amount Paid By Insurance"
                value={formData.amountPaidByInsurance}
                onChange={handleChange}
                className="w-full border px-3 py-2 rounded"
              />

              <input
                type="number"
                name="amountPaidByCustomer"
                placeholder="Amount Paid By Customer"
                value={formData.amountPaidByCustomer}
                onChange={handleChange}
                className="w-full border px-3 py-2 rounded"
              />

              <input
                type="number"
                name="billingAmount"
                placeholder="Billing Amount"
                value={formData.billingAmount}
                onChange={handleChange}
                className="w-full border px-3 py-2 rounded"
              />

              <input
                type="number"
                name="taxAmount"
                placeholder="Tax Amount"
                value={formData.taxAmount}
                onChange={handleChange}
                className="w-full border px-3 py-2 rounded"
              />

              <input
                type="number"
                name="laborCost"
                placeholder="Labor Cost"
                value={formData.laborCost}
                onChange={handleChange}
                className="w-full border px-3 py-2 rounded"
              />

              <input
                type="number"
                name="discountPercentage"
                placeholder="Discount %"
                value={formData.discountPercentage}
                onChange={handleChange}
                className="w-full border px-3 py-2 rounded"
              />

              <input
                type="number"
                name="discountAmount"
                placeholder="Discount Amount"
                value={formData.discountAmount}
                onChange={handleChange}
                className="w-full border px-3 py-2 rounded"
              />

              <input
                type="number"
                name="taxPercentage"
                placeholder="Tax Percentage"
                value={formData.taxPercentage}
                onChange={handleChange}
                className="w-full border px-3 py-2 rounded"
              />

              <input
                type="number"
                name="cgstPercentage"
                placeholder="CGST Percentage"
                value={formData.cgstPercentage}
                onChange={handleChange}
                className="w-full border px-3 py-2 rounded"
              />

              <input
                type="number"
                name="cgstAmount"
                placeholder="CGST Amount"
                value={formData.cgstAmount}
                onChange={handleChange}
                className="w-full border px-3 py-2 rounded"
              />

              <input
                type="number"
                name="sgstPercentage"
                placeholder="SGST Percentage"
                value={formData.sgstPercentage}
                onChange={handleChange}
                className="w-full border px-3 py-2 rounded"
              />

              <input
                type="number"
                name="sgstAmount"
                placeholder="SGST Amount"
                value={formData.sgstAmount}
                onChange={handleChange}
                className="w-full border px-3 py-2 rounded"
              />

              <input
                type="number"
                name="amountSaved"
                placeholder="Amount Saved"
                value={formData.amountSaved}
                onChange={handleChange}
                className="w-full border px-3 py-2 rounded"
              />

              <input
                type="number"
                name="costToCompany"
                placeholder="Cost To Company"
                value={formData.costToCompany}
                onChange={handleChange}
                className="w-full border px-3 py-2 rounded"
              />

              <input
                type="text"
                name="invoiceNo"
                placeholder="Invoice Number"
                value={formData.invoiceNo}
                onChange={handleChange}
                className="w-full border px-3 py-2 rounded"
              />

              <div>
                <label className="text-sm text-gray-600">Invoice Date</label>
                <input
                  type="date"
                  name="invoiceDate"
                  value={formData.invoiceDate}
                  onChange={handleChange}
                  className="w-full border px-3 py-2 rounded"
                />
              </div>

              {/* <input
                type="number"
                name="amountPaid"
                placeholder="Total Amount Paid"
                value={formData.amountPaid}
                onChange={handleChange}
                className="w-full border px-3 py-2 rounded"
              />

              <input
                type="text"
                name="transactionId"
                placeholder="Transaction ID"
                value={formData.transactionId}
                onChange={handleChange}
                className="w-full border px-3 py-2 rounded"
              />

              <input
                type="text"
                name="modeOfPayment"
                placeholder="Mode of Payment"
                value={formData.modeOfPayment}
                onChange={handleChange}
                className="w-full border px-3 py-2 rounded"
              />

              <div>
                <label className="text-sm text-gray-600">
                  Transaction Date
                </label>
                <input
                  type="date"
                  name="transactionDate"
                  value={formData.transactionDate}
                  onChange={handleChange}
                  className="w-full border px-3 py-2 rounded"
                />
              </div> */}

              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <div className="flex flex-col gap-1">
                  <label className="text-sm font-medium text-gray-600">
                    Is Credit Applied
                  </label>
                  <select
                    name="isCreditApplied"
                    value={formData.isCreditApplied ?? ""}
                    onChange={handleChange}
                    className="border border-gray-300 rounded-lg px-3 py-2 text-sm
                 focus:outline-none focus:ring-2 focus:ring-blue-500
                 focus:border-blue-500 transition"
                  >
                    <option value="" disabled>
                      Select an option
                    </option>
                    <option value="1">Yes</option>
                    <option value="0">No</option>
                  </select>
                </div>

                <div className="flex flex-col gap-1">
                  <label className="text-sm font-medium text-gray-600">
                    Is Insurance Claimed
                  </label>
                  <select
                    name="isInsuranceClaimed"
                    value={formData.isInsuranceClaimed ?? ""}
                    onChange={handleChange}
                    className="border border-gray-300 rounded-lg px-3 py-2 text-sm
                 focus:outline-none focus:ring-2 focus:ring-blue-500
                 focus:border-blue-500 transition"
                  >
                    <option value="" disabled>
                      Select an option
                    </option>
                    <option value="1">Yes</option>
                    <option value="0">No</option>
                  </select>
                </div>
              </div>

              <div>
                <label className="text-sm text-gray-600">Description</label>
                <input
                  type="text"
                  name="description"
                  value={formData.description}
                  onChange={handleChange}
                  className="w-full border px-3 py-2 rounded"
                />
              </div>

              {/* Invoice Attachment */}
              <label>
                Invoice Attachment
                <input
                  type="file"
                  name="invoiceBillAttachment"
                  multiple
                  onChange={(e) =>
                    handleFileChange(e.target.files, "invoiceBillAttachment")
                  }
                  className="w-full border px-3 py-2 rounded"
                />
              </label>

              {/* General Attachments */}
              <label>
                Attachments
                <input
                  type="file"
                  name="attachment"
                  multiple
                  onChange={(e) =>
                    handleFileChange(e.target.files, "attachment")
                  }
                  className="w-full border px-3 py-2 rounded"
                />
              </label>

              {/* Preview */}
              <div className="flex gap-2 mt-2 flex-wrap col-span-3">
                {formData.attachment?.map((file, i) => (
                  <img
                    key={i}
                    src={file.url || file?.path || file?.Location || file}
                    alt="preview"
                    className="w-10 h-10 object-cover rounded-md border"
                  />
                ))}
                {formData.invoiceBillAttachment?.map((file, i) => (
                  <img
                    key={i}
                    src={file.url || file?.path || file?.Location || file}
                    alt="preview"
                    className="w-10 h-10 object-cover rounded-md border"
                  />
                ))}
              </div>
            </form>

            <button
              type="submit"
              onClick={() => {
                handleaddBillingDetails();
              }}
              className="w-full bg-blue-500 text-white py-2 rounded hover:bg-blue-600 mt-4"
            >
              Submit
            </button>
            {isEditing && (
              <button
                type="button"
                onClick={handleCancelEdit}
                className="w-full bg-gray-300 text-gray-800 py-2 rounded hover:bg-gray-400 mt-2"
              >
                Cancel
              </button>
            )}
          </>
        )}
      </div>
    </>
  );
};

export default Billingdetails;
